import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { deletePackage, putPackages } from "store/packages/actions";
import { connect } from 'react-redux'
import FontIcon from 'material-ui/FontIcon';
import { translate } from "react-i18next";
import { MenuItem } from 'material-ui'
import { push } from 'react-router-redux'


class PackageDeleteDialog extends Component {
    constructor() {
        super();
        // this.state = {
        //     open: false,
        // };
    }

    // handleOpen = () => {
    //     this.setState({
    //         open: true
    //     })
    // };

    // handleClose = () => {
    //     this.setState({open: false});
    // };

    handleSubmit = () => {
        this.props.handleSubmit(this.props.package)
    };

    render() {
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                // primary={true}
                onClick={this.props.onCancelClick}
                key="cancel"
            />,
            <FlatButton
                label={this.props.t('dialog_delete')}
                primary={true}
                key="submit"
                onClick={this.handleSubmit}
            // onClick={this.handleClose}
            />,
        ];

        return (
            <Dialog autoScrollBodyContent={true} open={this.props.open} title={this.props.t('package_management_delete_package') + ' ' + this.props.package.name}>
                <p>{this.props.t('package_management_delete_package_message')}</p>
                <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
                    {actions}
                </div>
            </Dialog>

        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleSubmit: (pckg) => {
            dispatch(deletePackage(pckg));
            dispatch(putPackages());
            dispatch(push('/'));
        }
    }
};

export default connect(null, mapDispatchToProps)(translate()(PackageDeleteDialog));



// WEBPACK FOOTER //
// ./src/components/packages/PackageDeleteDialog.js